<template>
  <b-form-group
    :id="formGroupId"
    :label="label"
    :label-for="id"
    label-class="label-bold"
    :invalid-feedback="errorMsg"
    :state="state"
  >
    <b-form-select
      v-model="selectedCountry"
      :options="options"
      :selected="selected"
      @change="showCountry($event)"
      :state="state"
      :disabled="isDisabled"
    ></b-form-select>
  </b-form-group>
</template>

<script>
import countries from '@/lib/data/countries';
import listModifier from '@/lib/dataListModifier';

var defaultTopCountries = [
  'US',
  'GB',
  'CA',
  'FR',
  'DE',
  'AU',
  'NZ',
  'PR',
  'ES',
  'IT',
  'AT',
  'CH',
  'IE',
];
var topItem = [['', 'Select your country / territory...']];

function loadCountries(optionsArr, dataTuples) {
  dataTuples.forEach((tuple) => {
    optionsArr.push({ value: tuple[0], text: tuple[1] });
  });
}
export default {
  name: 'SelectListCountries',
  props: {
    topCountries: {
      default: function () {
        return defaultTopCountries;
      },
    },
    selected: {
      default: '',
    },
    id: {},
    label: {},
    state: {
      default: null,
    },
    errorMsg: {},
    disabled: null,
  },

  data: function () {
    return {
      options: [],
    };
  },
  computed: {
    formGroupId: function () {
      return this.id + '-group';
    },
    isDisabled: function () {
      return this.disabled;
    },
    selectedCountry: {
      get: function () {
        return this.selected;
      },
      set: function (countryCode) {
        return countryCode;
      },
    },
  },
  methods: {
    showCountry: function (val) {
      // console.log('state val is', val);
      this.$emit('country-selected', val);
    },
  },

  created() {
    var countriesTuplesOrdered = listModifier.generateTwoGroupedList(
      countries,
      this.topCountries,
      '',
      true,
      '',
      topItem
    );

    loadCountries(this.options, countriesTuplesOrdered);
  },
};
</script>

<style>
</style>